import { setup, scan, route } from '@lernetz/ts-lib';
import {AppController} from './components/app/App';
import { modelRegistry, viewRegistry } from './register';
import {languageService} from './services/lang';
import {getState, setState} from './state';
// extend HttpRequest with a method (move to ts-lib)
//
import "../styling/main.css";

export function init( setupData ) {
    setup(setupData, modelRegistry);

    setState(setupData);

    languageService.determineLanguage();

    // set translation for svelte

    const data = {
        ...setupData.data,
        ctrl: new AppController(),
    };
    setState({ ...getState(), scroll: data.ctrl.scrollEvent });

    scan({ root: document.body, registry: viewRegistry, data });
}
